module.exports = __webpack_public_path__ + "static/img/map.b19a350.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/map.png
// module id = m0WX
// module chunks = 1